<template>
    <div>
        <!-- 属性別画像グリッド -->
        <div class="attribute-images-grid">
            <div
                v-for="(image, index) in images"
                :key="image.id"
                class="attribute-image-item"
                @click="openModal(index)"
            >
                <webp-picture v-if="image.webp_path" :webp="image.webp_path" class="inherit">
                    <img
                        :src="image.img_file"
                        :alt="`${talentName} ${attributeName}`"
                        loading="lazy"
                        class="attribute-image clickable"
                    >
                </webp-picture>
                <img
                    v-else
                    :src="image.img_file"
                    :alt="`${talentName} ${attributeName}`"
                    loading="lazy"
                    class="attribute-image clickable"
                >
            </div>
        </div>

        <!-- サンプル画像モーダル -->
        <sample-image-modal
            :show="showModal"
            :image-data="currentImageData"
            :show-talent-button="showTalentButton"
            @close="closeModal"
        ></sample-image-modal>
    </div>
</template>

<script>
export default {
    props: {
        /** 表示する画像の配列 */
        images: {
            type: Array,
            required: true
        },
        /** モーダル表示用の詳細情報付き画像配列 */
        imagesWithDetail: {
            type: Array,
            required: true
        },
        /** モーダルに「モデル詳細へ」ボタンを表示するか */
        showTalentButton: {
            type: Boolean,
            default: true
        },
        /** タレント名（alt属性用） */
        talentName: {
            type: String,
            default: ''
        },
        /** 属性名（alt属性用） */
        attributeName: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            showModal: false,
            currentImageData: {}
        };
    },
    methods: {
        /**
         * モーダルを開く
         * @param {number} index - クリックされた画像のインデックス
         */
        openModal(index) {
            if (this.imagesWithDetail[index]) {
                this.currentImageData = this.imagesWithDetail[index];
                this.showModal = true;

                // GAイベント送信
                this.sendImageClickToGa(this.imagesWithDetail[index]);
            }
        },

        /**
         * モーダルを閉じる
         */
        closeModal() {
            this.showModal = false;
        },

        /**
         * 画像クリックイベントをGoogle Analyticsに送信
         * @param {Object} imageData - 画像データ
         */
        sendImageClickToGa(imageData) {
            // タレント詳細ページ（/talent/{id}/{name}/attribute/{attributeId}）の場合は送信しない
            const pathname = window.location.pathname;
            let pageName = '写真館';
            const attrMatch = pathname.match(/^\/talent\/\d+\/[^/]+\/attribute\/(\d+)$/);
            if (attrMatch) {
                pageName = this.attributeName;
            }

            // 検索キーワードを取得
            const urlParams = new URLSearchParams(window.location.search);
            const keyword = urlParams.get('keyword') || '';

            // GA送信用のデータを構築
            const imageModel = imageData.talents && imageData.talents.length > 0
                ? imageData.talents.join(',')
                : '';
            const imageItem = imageData.item_title || '';
            const imageURL = imageData.img_file || '';

            if (typeof gtag !== 'undefined') {
                gtag('event', 'imageClick', {
                    'imageModel': imageModel,
                    'imageItem': imageItem,
                    'imageURL': imageURL,
                    'inputKeyword': keyword,
                    'pageName': pageName,
                });
            }
        }
    }
};
</script>

<style scoped>
/* ========================================
   グリッドレイアウト
   ======================================== */
.attribute-images-grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 16px;
    margin-bottom: 32px;
}

/* ========================================
   画像アイテム
   ======================================== */
.attribute-image-item {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 141.4%; /* A4比率 (1:√2) */
    overflow: hidden;
    background-color: #f5f5f5;
    border-radius: 4px;
    cursor: pointer;
}

.attribute-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
}

/* ========================================
   ホバー効果
   ======================================== */
.attribute-image.clickable {
    transition: opacity 0.2s;
}

.attribute-image-item:hover .attribute-image.clickable {
    opacity: 0.8;
}

/* ========================================
   レスポンシブ対応（SP）
   ======================================== */
@media (max-width: 767px) {
    .attribute-images-grid {
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;
        margin-bottom: 24px;
    }
}
</style>
